import { buildFrontUrl } from "@/lib/front-url"

interface StandaloneWebphoneSessionLike {
  isValidSessionData?: boolean
  launcherID?: string
  launcherURL?: string
  jSessionID?: string
}

interface StandaloneWebphoneUserLike {
  user?: {
    id?: number
  }
  cluster?: {
    launcherUrlS?: string
  }
  twilio?: {
    syncToken?: string
  }
}

export function buildStandaloneWebphoneLoginUrl(frontUrl: string | undefined): string {
  return buildFrontUrl("/login", {
    frontUrl,
  })
}

export function isStandaloneWebphonePath(pathname: string): boolean {
  if (!pathname) return false

  const normalizedPath = pathname.endsWith("/") && pathname !== "/" ? pathname.slice(0, -1) : pathname
  return normalizedPath === "/webphone"
}

export function hasUsableStandaloneWebphoneSession(appData: StandaloneWebphoneSessionLike): boolean {
  return Boolean(appData.isValidSessionData && appData.launcherID && appData.launcherURL && appData.jSessionID)
}

export function hasStandaloneWebphoneRequestCredentials(appData: StandaloneWebphoneSessionLike): boolean {
  return Boolean(appData.launcherID && appData.jSessionID)
}

export function hasUsableStandaloneWebphoneUserData(userData: StandaloneWebphoneUserLike): boolean {
  return Boolean(userData.user?.id && userData.user.id > 0 && userData.cluster?.launcherUrlS && userData.twilio?.syncToken)
}

export function getStandaloneWebphoneCacheControl(): string {
  return "private, no-store, no-cache, must-revalidate"
}
